/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { filter, includes, map } from 'lodash';
import { documentActions } from '../DocumentActions/constants';
export const mapDownloadableDocIds = documents => {
  const downloadableDocs = filter(documents, doc => isDocDownloadable(doc));
  const downloadableDocIds = map(downloadableDocs, _ref => {
    let {
      _id
    } = _ref;
    return _id;
  });
  return downloadableDocIds;
};
export const isDocDownloadable = doc => includes(doc.actions, documentActions.DOWNLOAD);